<div class="container">
  <div class="icon-container">
    <i class="material-icons">
      headset_mic
    </i>
    <a  (click)="openSettings()">{{ 'public.settings'| translate}}</a>
  </div>
  <div class="message-container">
    <div>
        <span> {{ message }}</span>
    </div>
    <div class="button-container">
      <button *ngIf="!hasNewDevices" mat-button (click)="close()" class="round-button" color="primary"><i class="material-icons">check</i>{{ 'public.ok'| translate}}</button>
      <button *ngIf="hasNewDevices" mat-button (click)="close()" class="round-button" color="primary"><i class="material-icons">cancel</i>{{ 'public.button.no'| translate}}</button>
      <button *ngIf="hasNewDevices" mat-button (click)="useNewDevices()" class="round-button" color="primary"><i class="material-icons">check</i>{{ 'public.button.yes'| translate}}</button>
    </div>
  </div>
</div>
